<template>
    <div>
    <b-modal
        :visible="isModalVisible"
        :centered="centered"
        :size="computedSize"
        :no-close-on-backdrop="true"
        hide-header-close
        :scrollable="scrollable"
        :modal-class="computedModalClass"
        @shown="onShown"
        @hidden="onHidden"
    >
        <template #modal-header>
            <h5 class="modal-title" style="font-weight: bold;">
                {{ modalTitle }}
            </h5>
            <b-icon
                @click="openOverLay"
                icon="x-lg"
                class="icon-close"
            ></b-icon>
        </template>

        <template #default>
            <slot name="content"></slot>
        </template>

        <template #modal-footer>
            <CustomButton label="Đóng" @click="openOverLay" :plain="true" />
            <slot name="btn-handle"></slot>
        </template>
    </b-modal>

    <!-- Dialog xác nhận rời trang (unsaved changes): nội dung cố định, không scroll -->
    <el-dialog
        :visible.sync="showOverLay"
        title="Thông báo"
        width="500px"
        append-to-body
        :close-on-click-modal="false"
        class="custom-modal-confirm-dialog"
    >
        <p class="mb-0 text-dark confirm-dialog-text" style="line-height: 1.5;">
            Các thông tin vừa nhập sẽ bị mất khi đóng trang. Thầy cô
            có muốn tiếp tục chỉnh sửa, kiểm tra và lưu lại thông tin đã nhập?
        </p>
        <span slot="footer">
            <CustomButton
                :plain="true"
                label="Tiếp tục chỉnh sửa"
                @click="closeOverLay"
            />
            <CustomButton
                style="background-color: var(--blue-200)"
                label="Rời khỏi trang"
                @click="closeModalHandler"
            />
        </span>
    </el-dialog>
    </div>
</template>

<script>
/**
 * Scroll trong modal:
 * - b-modal: prop scrollable điều khiển scroll body (khi true, nội dung dài scroll trong .modal-body).
 * - Popup xác nhận rời trang (el-dialog): nội dung cố định, không scroll (đã tắt overflow).
 */
import CustomButton from './CustomButton.vue'
export default {
    components: { CustomButton },
    props: {
        isModalVisible: {
            type: Boolean,
            required: true
        },
        modalTitle: {
            type: String,
            default: ''
        },
        closeFunction: {
            type: Function,
            default: () => {}
        },
        centered: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'md' 
        },
        // Thêm prop width để nhận giá trị px (VD: '800px' hoặc 800)
        width: {
            type: [String, Number],
            default: null
        },
        errModal: { type: Boolean },
        scrollable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showOverLay: false,
            interval: null
        }
    },
    beforeDestroy() {
        this.clearInterval()
    },
    methods: {
        openOverLay() {
            if (this.errModal === true) {
                this.showOverLay = true
            } else {
                this.closeModalHandler()
                this.showOverLay = false
            }
        },
        closeOverLay() {
            this.showOverLay = false
        },
        closeModalHandler() {
            this.closeOverLay()
            this.closeFunction()
            this.$emit('hidden')
        },
        clearInterval() {
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        onShown() {
            // Logic cũ focus vào confirm dialog
            if (this.$refs.dialog && this.showOverLay) {
                this.$refs.dialog.focus()
            }
            
            // Logic mới: Set width chính xác nếu có prop width
            this.updateCustomWidth()
        },
        // Hàm xử lý set width trực tiếp vào DOM
        updateCustomWidth() {
            if (this.width && !this.showOverLay) {
                // Tìm element modal-dialog dựa trên class định danh unique
                const modalDialog = document.querySelector(`.custom-modal-${this._uid} .modal-dialog`)
                
                if (modalDialog) {
                    const widthValue = typeof this.width === 'number' ? `${this.width}px` : this.width
                    // Set max-width đè lên style của bootstrap
                    modalDialog.style.maxWidth = widthValue
                    modalDialog.style.width = widthValue
                }
            }
        },
        onHidden() {
            const submitRef = this.$refs.submit
            if (submitRef && submitRef.$el) {
                submitRef.$el.focus()
            }
        }
    },
    computed: {
        computedSize() {
            // Nếu đang hiện overlay confirm -> dùng size lg
            if (this.showOverLay) return 'lg'
            
            // Nếu có custom width -> bỏ trống size để Bootstrap không gán class mặc định (sm/lg/xl)
            // và để logic JS tự xử lý width
            if (this.width) return ''
            
            return this.size
        },
        computedModalClass() {
            let classes = ''; 
    
    classes += ` custom-modal-${this._uid}`
    return classes
        }
    },
    watch: {
        // Cập nhật lại width nếu prop thay đổi trong khi modal đang mở
        width() {
            if (this.isModalVisible) {
                this.$nextTick(() => {
                    this.updateCustomWidth()
                })
            }
        },
        showOverLay(newVal) {
            // Khi tắt overlay confirm, cần set lại width custom cho modal chính
            if (!newVal) {
                this.$nextTick(() => {
                    this.updateCustomWidth()
                })
            }
        }
    }
}
</script>

<style scoped>
::v-deep .modal-header {
    align-items: center !important;
    background-color: var(--white-common);
    color: #212529;
}

.icon-close {
    cursor: pointer;
}

.icon-close:hover {
    color: var(--blue-200);
}

/* Allow poppers (body-appended) to show above modal and avoid clipping */
::v-deep .modal-dialog,
::v-deep .modal-content {
    overflow: visible !important;
}

/* Header và footer cố định giữa màn hình, main scroll (không fix cứng chiều cao) */
::v-deep .modal-content {
    display: flex !important;
    flex-direction: column !important;
    max-height: 90vh !important;
}
::v-deep .modal-header {
    flex-shrink: 0 !important;
}
::v-deep .modal-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    overflow-y: auto !important;
}
::v-deep .modal-footer {
    flex-shrink: 0 !important;
}

/* Ensure element-ui poppers get a safe z-index above bootstrap modal/backdrop */
::v-deep .el-popper,
::v-deep .el-select-dropdown,
::v-deep .el-select-dropdown__wrap,
::v-deep .el-select-dropdown__list {
    z-index: 2050 !important;
}

/* In case of inline render (append-to-body=false), make dropdown width stretch to container */
::v-deep .select-wrapper .el-select-dropdown {
    width: 100% !important;
    min-width: 100% !important;
    box-sizing: border-box !important;
}

/* Improved scrollable modal body */
::v-deep .modal-body-scrollable {
    max-height: 60vh;
    overflow-y: auto;
    padding: 15px 20px;
}

/* Better scrollbar styling */
::v-deep .modal-body-scrollable::-webkit-scrollbar {
    width: 8px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Expand XL modal to be wider for better content display */
::v-deep .modal-xl {
    max-width: 90% !important;
}

::v-deep .modal-xl .modal-dialog {
    max-width: 90% !important;
}

::v-deep .el-dialog__body {
    word-break: normal !important;
}

@media (min-width: 1200px) {
    ::v-deep .modal-xl {
        max-width: 85% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 85% !important;
    }
}

@media (min-width: 1400px) {
    ::v-deep .modal-xl {
        max-width: 80% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 80% !important;
    }
}

@media (min-width: 1600px) {
    ::v-deep .modal-xl {
        max-width: 75% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 75% !important;
    }
}

/* Confirm dialog: nội dung cố định, không cần scroll */
.custom-modal-confirm-dialog .el-dialog__body {
    overflow: visible !important;
    max-height: none !important;
}
</style>